import { Component, Input } from '@angular/core';

@Component({
  selector: 'lib-developer-page',
  templateUrl: './developer-page.component.html',
  styleUrls: ['./developer-page.component.scss']
})
export class DeveloperPageComponent {
  @Input() withMainHeadline = true;
  activeIndex: number = 0;

 
}
